import React from 'react';
import ReactDOM from 'react-dom/client';
import 'src/index.css';
import App from 'src/App';
import reportWebVitals from 'src/reportWebVitals';
import UserService from 'src/services/UserService';
import * as UserServiceSession from 'src/services/UserServiceSession';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/es';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Render de carga mientras Keycloak autentica
root.render(<div style={{ padding: '50px', textAlign: 'center' }}>Cargando sesión...</div>);


UserService.initKeycloak(async () => {

    await UserServiceSession.initSession();

    root.render(
        <React.StrictMode>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="es"
            >
                <App />
            </LocalizationProvider>
        </React.StrictMode>
    );
});

reportWebVitals();
